// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3495":"6193eb13","3527":"532ec94a","3756":"e97c557c","4369":"c8bb68e3","5285":"0f53f2ec","7451":"0f53f2ec"}[chunkId] + ".chunk.css";
};